export default "__VITE_ASSET__Dg0Zc7lB__"